<template>
  <v-container
    id="icons-view"
    fluid
    tag="section"
  >
    <view-intro
      heading="Icons"
      link="components/icons"
    />

    <v-row>
      <v-col cols="12">
        <material-card>
          <v-row
            align="center"
            justify="center"
          >
            <v-col
              v-for="icon in icons"
              :key="icon"
              class="ma-2"
              cols="auto"
            >
              <v-tooltip top>
                <template v-slot:activator="{ attrs, on }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ icon }}
                  </v-icon>
                </template>
                <span>{{ icon }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </material-card>
      </v-col>

      <v-col
        class="mx-auto"
        cols="auto"
      >
        <app-btn
          href="https://materialdesignicons.com/"
          large
          rel="noopener noreferrer"
          target="_blank"
        >
          <v-icon left>
            mdi-material-design
          </v-icon>

          <span>See all icons</span>
        </app-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'IconsView',

    data: () => ({
      icons: [
        'mdi-weather-sunset-down',
        'mdi-weather-sunset-up',
        'mdi-weather-cloudy',
        'mdi-tools',
        'mdi-arrow-down',
        'mdi-arrow-up',
        'mdi-text-box-multiple',
        'mdi-text-box',
        'mdi-text-box-check',
        'mdi-text-box-plus',
        'mdi-text-box-minus',
        'mdi-tag-text',
        'mdi-smart-card',
        'mdi-shield-account',
        'mdi-shield-airplane',
        'mdi-shield-plus',
        'mdi-shield-remove',
        'mdi-printer',
        'mdi-plus-circle',
        'mdi-minus-circle',
        'mdi-pencil',
        'mdi-pen',
        'mdi-note-text',
        'mdi-map-marker',
        'mdi-map',
        'mdi-image',
        'mdi-image-multiple',
        'mdi-image-plus',
        'mdi-home',
        'mdi-folder',
        'mdi-folder-edit',
        'mdi-folder-multiple',
        'mdi-file',
        'mdi-file-multiple',
        'mdi-file-document',
        'mdi-file-document-multiple',
        'mdi-file-image',
        'mdi-eye',
        'mdi-email',
        'mdi-download',
        'mdi-download-circle',
        'mdi-delete',
        'mdi-credit-card',
        'mdi-cloud',
        'mdi-certificate',
        'mdi-card-account-details',
        'mdi-cash',
        'mdi-cash-multiple',
        'mdi-cash-plus',
        'mdi-card-bulleted',
        'mdi-calendar',
        'mdi-account',
        'mdi-account-cash',
        'mdi-account-multiple',
        'mdi-account-plus',
        'mdi-account-minus',
        'mdi-account-group',
        'mdi-airplane',
        'mdi-airplane-landing',
        'mdi-airplane-takeoff',
        'mdi-airport',
        'mdi-information',
        'mdi-history',
      ],
    }),
  }
</script>
